import React from 'react';
import VoxelTooltipShort from './Tooltip/VoxelTooltipShort';

export interface VoxelAvatarProps {
  name?: string;
  archived?: boolean;
  tooltip?: React.ReactNode;
  enableTooltip?: boolean;
  size?: AvatarSize;
  error?: boolean;
  colorOverride?: string;
  img?: string;
}

export type AvatarSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

const colors = [
  'bg-[#69938c]',
  'bg-[#466263]',
  'bg-[#8dc3ae]',
  'bg-[#323f4f]',
  'bg-[#5c6a7b]',
  'bg-[#0b1927]',
];

export const VoxelAvatar: React.FC<VoxelAvatarProps> = ({
  name,
  archived = false,
  tooltip,
  enableTooltip = false,
  size = 'sm',
  error,
  colorOverride,
  img,
}) => {
  if (name === null || name === undefined) {
    name = '';
  }
  const letters = name
    ?.split(' ')
    .map((word) => word?.slice(0, 1)?.toUpperCase())
    ?.slice(0, 2)
    ?.join('');

  // Calculate color
  // It becomes somewhat random but deterministic per user
  const deterministicClientNumber = name?.length + name?.charCodeAt(0);
  let color = colors[deterministicClientNumber % colors.length];

  if (!color?.length) {
    color = 'bg-voxel-gray-100';
  }

  if (!!colorOverride) color = colorOverride;

  // Render
  if (!name && !img) return null;

  if (img) {
    return (
      <VoxelTooltipShort message={tooltip} disabled={!tooltip}>
        <img
          src={img}
          className={`
          w-auto rounded-full
          ${size === 'sm' ? 'h-6 w-6' : ''} 
          ${size === 'md' ? 'h-7 w-7' : ''} 
          ${size === 'lg' ? 'h-8 w-8' : ''} 
          ${size === 'xl' ? 'h-16 w-16' : ''} 
          ${size === 'xxl' ? 'h-24 w-24' : ''} 
      
    `}
        />
      </VoxelTooltipShort>
    );
  }

  return (
    <VoxelTooltipShort message={tooltip} disabled={!tooltip}>
      <div
        className={`rounded-full text-center flex flex-row justify-center items-center
            ${size === 'sm' ? 'h-6 w-6 text-sm' : ''} 
            ${size === 'md' ? 'h-7 w-7 text-sm' : ''} 
            ${size === 'lg' ? 'h-8 w-8 text-base' : ''} 
            ${size === 'xl' ? 'h-16 w-16 text-2xl' : ''} 
            ${size === 'xxl' ? 'h-24 w-24 text-5xl' : ''} 
            ${archived ? 'text-black bg-voxel-gray-300' : ''}
            ${!archived ? `${color} text-white` : ''}
            ${error ? 'shadow-avatar-glow shadow-error-500 ' : ''}
        `}
      >
        {letters}
      </div>
    </VoxelTooltipShort>
  );
};

export default VoxelAvatar;
